import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from 'modules/global/adapters';
import {
  BulkReleaseRightActionRequest,
  BulkAssignBargeRailPickUpRequest,
  GreenLightValuesRequest,
} from 'modules/global/adapters/crpAPI';
import { acceptReleaseRightKeys } from './queryKeys';

export const useGetActiveTerminals = () => {
  return useQuery(acceptReleaseRightKeys.getTerminals(), () => api.terminals.getTerminals());
};

export const useGetGreenLightValues = (greenLightNames: string[]) => {
  const request = {
    greenLightNames: greenLightNames,
  } as GreenLightValuesRequest;

  return useQuery(acceptReleaseRightKeys.getGreenLightValues(), () =>
    api.greenLights.getGreenLightValues(request)
  );
};

export const useGetPendingContainers = () => {
  return useQuery(acceptReleaseRightKeys.getPendingContainersForReleaseRightAction(), () =>
    api.containers.getPendingContainersForReleaseRightAction()
  );
};

export const usePostContainersAccept = () => {
  return useMutation(acceptReleaseRightKeys.postContainersAccept(), {
    mutationFn: (data: BulkReleaseRightActionRequest) =>
      api.releaserights.postContainersAccept(data),
  });
};

export const usePostContainersAssign = () => {
  const queryClient = useQueryClient();

  return useMutation(acceptReleaseRightKeys.postContainersAssign(), {
    mutationFn: (data: BulkAssignBargeRailPickUpRequest) =>
      api.pickuprights.postContainersAssignBargeRailPickUp(data),
    onSuccess: () => {
      // We will invalidate all queries that are used in the update terminal action
      // not a specific filtered one
      queryClient.invalidateQueries(acceptReleaseRightKeys.containersForUpdateRoot());
    },
  });
};

export const useGetContainerDetail = (id: string) => {
  return useQuery(acceptReleaseRightKeys.getContainerDetail(id), () =>
    api.containers.getContainerDetail(id)
  );
};
